module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/hero-mobile-e30c8233545cb82bc5d010c4af7a749d.png";